export default {
  SET_PAYMENT_GATEWAY(state, payload) {
    state.paymentGateway = payload;
  },
  SET_SINGLE_PAYMENT_GATEWAY(state, payload) {
    state.singlePaymentGateway = payload;
  },
};
